import {
  List,
  Datagrid,
  TextField,
  ExportButton,
  TopToolbar,
  TextInput,
  FunctionField,
  useRecordContext,
} from 'react-admin';
import { Box, Typography, Chip, Avatar } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';

const countryFilters = [
  <TextInput key="nameEn" label="İngilizce isim" source="nameEn" alwaysOn variant="outlined" />,
];

const ListActions = () => (
  <TopToolbar>
    <ExportButton
      sx={{
        backgroundColor: '#7367f0',
        color: 'white',
        '&:hover': { backgroundColor: '#5549d9' },
      }}
    />
  </TopToolbar>
);

const CountryInfo = () => {
  const record = useRecordContext();
  if (!record) return null;

  const getRandomEmoji = (id: number) => {
    const emojis = ['🇺🇸', '🇬🇧', '🇩🇪', '🇫🇷', '🇪🇸', '🇮🇹', '🇷🇺', '🇨🇳', '🇯🇵', '🇰🇷', '🇧🇷', '🇮🇳', '🇹🇷', '🇳🇱', '🇵🇱'];
    return emojis[id % emojis.length];
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
      <Avatar
        sx={{
          width: 44,
          height: 44,
          backgroundColor: 'rgba(255, 159, 67, 0.12)',
          fontSize: '1.25rem',
        }}
      >
        {getRandomEmoji(record.countryId)}
      </Avatar>
      <Box>
        <Typography variant="body2" sx={{ fontWeight: 600, color: '#d0d2d6' }}>
          {record.nameEn}
        </Typography>
        <Box sx={{ display: 'flex', gap: 0.5, mt: 0.5 }}>
          <Chip
            label={`ID: ${record.countryId}`}
            size="small"
            sx={{
              height: 18,
              fontSize: '0.6rem',
              backgroundColor: 'rgba(0, 207, 232, 0.12)',
              color: '#00cfe8',
              fontWeight: 600,
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};

const StatusIcon = ({ isActive }: { isActive: boolean }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
    {isActive ? (
      <CheckCircleIcon sx={{ color: '#28c76f', fontSize: 20 }} />
    ) : (
      <CancelIcon sx={{ color: '#ea5455', fontSize: 20 }} />
    )}
  </Box>
);

const VisibleField = () => {
  const record = useRecordContext();
  if (!record) return null;
  return <StatusIcon isActive={record.visible} />;
};

const RetryField = () => {
  const record = useRecordContext();
  if (!record) return null;
  return <StatusIcon isActive={record.retry} />;
};

export const CountryList = () => (
  <Box>
    <Box sx={{ mb: 3 }}>
      <Typography variant="h5" sx={{ fontWeight: 700, color: '#d0d2d6' }}>
        Ülkeler
      </Typography>
      <Typography variant="body2" sx={{ color: '#676d7d', mt: 0.5 }}>
        Desteklenen ülkeleri görüntüleyin
      </Typography>
    </Box>

    <List
      filters={countryFilters}
      actions={<ListActions />}
      sort={{ field: 'countryId', order: 'ASC' }}
      sx={{
        '& .RaList-main': {
          backgroundColor: '#283046',
          borderRadius: '12px',
          overflow: 'hidden',
        },
      }}
    >
      <Datagrid
        bulkActionButtons={false}
        sx={{
          '& .RaDatagrid-headerCell': {
            backgroundColor: '#242b3d',
            fontWeight: 600,
            color: '#676d7d',
            fontSize: '0.75rem',
            textTransform: 'uppercase',
            letterSpacing: '0.05em',
          },
          '& .RaDatagrid-row:hover': {
            backgroundColor: '#242b3d',
          },
          '& .RaDatagrid-rowCell': {
            borderColor: '#404656',
          },
        }}
      >
        <FunctionField label="Ülke" render={() => <CountryInfo />} />
        <TextField source="nameRu" label="Rusça" />
        <TextField source="nameCh" label="Çince" />
        <FunctionField label="Görünür" render={() => <VisibleField />} />
        <FunctionField label="Retry" render={() => <RetryField />} />
      </Datagrid>
    </List>
  </Box>
);
